import { createContext, useContext } from 'react';

/**
 * Based on: https://usehooks.com/useAuth/
 */
const HybridContext = createContext({});

export const useHybrid = () => useContext(HybridContext);

export default HybridContext;
